import { Navigate, useLocation } from "react-router-dom";
import { buildLoginUrl } from "../utils/authRedirect";

interface ProtectedRouteProps {
  children: React.ReactNode;
  isAuthenticated: boolean;
}

const ProtectedRoute = ({ children, isAuthenticated }: ProtectedRouteProps) => {
  const location = useLocation();

  if (!isAuthenticated) {
    const returnUrl = `${location.pathname}${location.search}${location.hash}`;
    return <Navigate to={buildLoginUrl({ returnUrl })} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
